import * as Yup from 'yup'

export const validationSchemas = () => {
   
    let validationObject = { };

    validationObject["montoRendido"] = Yup.string().required('Este campo es obligatorio.');
    validationObject["fechaTransaccion"] = Yup.string().required('Este campo es obligatorio.');

    validationObject.fileComprobante = Yup
    .mixed()
    .required('Debe adjuntar Comprobante.')
    .test('fileSize', 'Tamaño máximo del archivo 5MB.',
        (value) => {
            if (!value) return true;
            return value.size <= (5 * 1000000);
        })
    validationObject["cuotasSeleccionadas"] = Yup.array()
    .min(1, 'Debe seleccionar al menos una cuota')
    .required('Este campo es obligatorio.');
    
    return Yup.object().shape(validationObject);
}